var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 55,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    fill: "#2566af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m56.07501,46.20499l-9.74,0l6.08,-37.38l9.74,0l-6.08,37.38zm-17.93,-37.38l-9.28,25.71l-1.09,-5.54l0,0l-3.28,-16.81s-0.39,-3.36 -4.61,-3.36l-15.34,0l-0.18,0.63s4.69,0.98 10.18,4.27l8.45,32.48l10.14,0l15.49,-37.38l-10.48,0zm76.56,37.38l8.94,0l-7.8,-37.38l-7.82,0c-3.61,0 -4.49,2.78 -4.49,2.78l-14.52,34.6l10.15,0l2.03,-5.55l12.37,0l1.14,5.55zm-10.71,-13.22l5.11,-13.99l2.88,13.99l-7.99,0zm-14.22,-15.17l1.39,-8.03s-4.29,-1.63 -8.75,-1.63c-4.83,0 -16.3,2.11 -16.3,12.37c0,9.66 13.46,9.78 13.46,14.86s-12.08,4.16 -16.06,0.96l-1.45,8.4s4.35,2.11 10.99,2.11c6.64,0 16.66,-3.44 16.66,-12.8c0,-9.72 -13.58,-10.63 -13.58,-14.85c0,-4.23 9.48,-3.69 13.64,-1.39z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#e6a540",
    d: "m27.77501,28.99499l-3.28,-16.81s-0.39,-3.36 -4.61,-3.36l-15.34,0l-0.18,0.63s7.37,1.53 14.44,7.25c6.76,5.47 8.97,12.29 8.97,12.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "none",
    d: "m2.13501,4.63499l125.73,0l0,44.73l-125.73,0l0,-44.73z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVisa);
export default __webpack_public_path__ + "static/media/logo-visa.a2c4a6ed3b903f381d42fcee756e6d1a.svg";
export { ForwardRef as ReactComponent };